import { render } from "./BrandLogoOverridesPage.vue?vue&type=template&id=1175cf73&scoped=true"
import script from "./BrandLogoOverridesPage.vue?vue&type=script&lang=js"
export * from "./BrandLogoOverridesPage.vue?vue&type=script&lang=js"

import "./BrandLogoOverridesPage.vue?vue&type=style&index=0&id=1175cf73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1175cf73"]])

export default __exports__